'use strict';

var _ = require('lodash');
var FaresAverageGridTransformerFactory = function FaresAverageGridTransformerFactory(DataTransformer, momentService, hepService, configurationService, fcrService) {
  function FaresAverageGridTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['fares-average-mode', 'fares-prev-average-mode'];
    this.targetType = ['fares-average', 'fares-average-prev'];
    this.priority = 1;
  }
  FaresAverageGridTransformer.prototype = Object.create(DataTransformer.prototype);
  FaresAverageGridTransformer.constructor = FaresAverageGridTransformer;
  FaresAverageGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) > -1 && this.targetType.indexOf(targetType) > -1;
  };
  FaresAverageGridTransformer.prototype.isCacheable = function () {
    return false;
  };
  FaresAverageGridTransformer.prototype.getCacheKey = function () {
    return this.sourceType.join('-') + '-' + this.targetType.join('-');
  };
  FaresAverageGridTransformer.prototype.transform = function (data) {
    var alertThreshold = hepService.getSimpleHepProperties().ALERT_THRESHOLD;
    if (data.domain.results) {
      var results = data.domain.results;
      for (var index = 0, dataLength = results.length; index < dataLength; index++) {
        var element = results[index];
        element.market = element.marketOrigin + '-' + element.marketDestination;
        element.bookingClass = element.className;
        var classesIndexes = getClassesIndexes(element.market);
        element.classIndex = classesIndexes[element.className];
        element.origin = element.marketOrigin;
        element.destination = element.marketDestination;
        element.applicableDateRangeBegin = momentService.of(element.applicableDateRangeBegin, momentService.FIELD.APPLICABLE_DATE_RANGE);
        element.applicableDateRangeEnd = momentService.of(element.applicableDateRangeEnd, momentService.FIELD.APPLICABLE_DATE_RANGE);
        element.lastProcessedDateMoment = momentService.of(element.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
        element.alertScore = summarizeAlertScore(element);
        element.alerts = element.alertScore;
        element.alertThresholdExceeded = element.alertScore > alertThreshold;
      }
      return _.sortBy(results, function (element) {
        return element.classIndex;
      });
    } else {
      return [];
    }
  };
  var getClassesIndexes = _.memoize(function (market) {
    var fcrTag = fcrService.getFcrTagForCurrentDateWithMarket(market);
    return configurationService.getClassIndexMapping(market, fcrTag);
  });
  function summarizeAlertScore(element) {
    return _.sum([element.fareDefaultingScore, element.fareInversionScore]) || undefined;
  }
  return FaresAverageGridTransformer;
};
FaresAverageGridTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'HepService', 'ConfigurationService', 'FcrService'];
module.exports = FaresAverageGridTransformerFactory;